import { FETCH_STATUS_CODE_MAPPING_SUCCESS } from './actions';

const reducer = (state = {}, action) => {
	switch (action.type) {
		case FETCH_STATUS_CODE_MAPPING_SUCCESS:
			return {
				...state,
				...action.payload,
			};

		default:
			return state;
	}
};
export default reducer;
